module.exports = __webpack_public_path__ + "8ee21d5711f3c63ec2d89d3623556be4.svg";